export enum GlobalETLStatus {
  HEALTHY = 'healthy',
  UNHEALTHY = 'unhealthy',
  NOT_RUNNING = 'not_running'
}
